import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { gender } from 'commons/types/dictionaries'
import { FF2, Select } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

import { useSubjectInformationItemContext } from '../../../SubjectInformationItemContext'

export const Gender = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()
  const { isAllInfoUnavailable } = useSubjectInformationItemContext()
  const isEntity = useWatch({ control, name: `subjectsInfo.${index as 0}.isEntity` })

  return (
    <Controller
      name={`subjectsInfo.${index as 0}.gender`}
      control={control}
      render={({ field }) => (
        <FF2
          field={field}
          label="8. Gender"
          input={(props) => (
            <Select
              {...props}
              data={gender}
              emptyOption={{ label: 'Not selected', value: '' }}
              disabled={isAllInfoUnavailable || isEntity}
            />
          )}
        />
      )}
    />
  )
}
